import { __decorate } from '../../../../../node_modules/tslib/tslib.es6.mjs.js';
import '../../../../../node_modules/@lit/reactive-element/reactive-element.js';
import { html as $, nothing as w } from '../../../../../node_modules/lit-html/lit-html.js';
import { LitElement as s } from '../../../../../node_modules/lit-element/lit-element.js';
import { property as e } from '../../../../../node_modules/@lit/reactive-element/decorators/property.js';
import { state as t } from '../../../../../node_modules/@lit/reactive-element/decorators/state.js';
import '../../../../../node_modules/@lit/reactive-element/decorators/query-assigned-elements.js';
import { ifDefined as l } from '../../../../../node_modules/lit-html/directives/if-defined.js';
import { addShowPopupEvent, addClosePopupEvent } from '../../../utilities/behavior-helpers/index.js';
import { getPlatformClass } from '../../../utilities/dom-helpers/index.js';
import css_248z from './styles/generic-button-updated.scss.js';

const isRecord = (v) => !!v && typeof v === 'object' && !Array.isArray(v);
const normalizeKey = (k) => (k.startsWith('aria-') ? k : `aria-${k}`);
const toStringVal = (v) => v === undefined || v === null || v === '' || v === false ? null : String(v);
const safeJsonParse = (s) => {
    try {
        return JSON.parse(s);
    }
    catch (_a) {
        return null;
    }
};
const fromArray = (arr) => arr.reduce((acc, item) => {
    if (!isRecord(item))
        return acc;
    const key = typeof item.key === 'string' ? normalizeKey(item.key) : '';
    const val = toStringVal(item.value);
    if (key && val)
        acc[key] = val;
    return acc;
}, {});
const fromRecord = (obj) => Object.entries(obj).reduce((acc, [rawK, rawV]) => {
    const key = normalizeKey(rawK);
    const val = toStringVal(rawV);
    if (val)
        acc[key] = val;
    return acc;
}, {});
const platformClass = getPlatformClass();
function parseAriaList(input) {
    const src = typeof input === 'string' ? safeJsonParse(input) : input;
    if (Array.isArray(src))
        return fromArray(src);
    if (isRecord(src))
        return fromRecord(src);
    return {};
}
const ariaListConverter = {
    fromAttribute: value => (value == null ? {} : parseAriaList(value)),
    toAttribute: () => null,
};
let iconsReadyInitialized = false;
const ICONS_READY_CLASS = 'icons-ready';
function initializeIconFontLoading() {
    if (iconsReadyInitialized || typeof document === 'undefined')
        return;
    iconsReadyInitialized = true;
    const addIconsReadyClass = () => {
        document.documentElement.classList.add(ICONS_READY_CLASS);
    };
    if (document.fonts) {
        document.fonts.ready
            .then(addIconsReadyClass)
            .catch(() => setTimeout(addIconsReadyClass, 3000));
    }
    else {
        addIconsReadyClass();
    }
}
class GenericButtonUpdated extends s {
    constructor() {
        super(...arguments);
        this.styleType = 'light';
        this.color = 'purple';
        this.type = 'primary';
        this.appearance = 'default';
        this.label = '';
        this.disabled = false;
        this.rtl = false;
        this.isLoading = false;
        this.isNoFollow = false;
        this.href = '';
        this.icon = '';
        this.customSvg = '';
        this.customSvgUrl = '';
        this.id = '';
        this.target = '';
        this.actionType = '';
        this.ariaList = {};
        this.skipAriaFallback = false;
        this.closeModal = false;
        this.download = false;
        this.modals = null;
        this._lastAppliedAria = {};
        this._handleClick = (ev) => {
            var _a;
            if (this.disabled || this.isLoading || this._ariaSaysDisabled()) {
                ev.preventDefault();
                ev.stopImmediatePropagation();
                return;
            }
            (_a = this.onClick) === null || _a === void 0 ? void 0 : _a.call(this, ev);
            this._emitClick(ev);
        };
    }
    connectedCallback() {
        var _a;
        super.connectedCallback();
        initializeIconFontLoading();
        this.classList.add(platformClass);
        if (this.popupId) {
            this.modals = document.querySelectorAll('cvt-modal, cvt-modal-updated');
            addShowPopupEvent(this.modals, this.popupId, this);
        }
        if (this.closeModal) {
            const modal = (this.closest('cvt-modal, cvt-modal-updated') ||
                ((_a = this.parentNode) === null || _a === void 0 ? void 0 : _a.parentNode));
            if (modal) {
                addClosePopupEvent(modal, this);
            }
        }
    }
    get isIconOnly() {
        return (this.appearance === 'icon-circle' || this.appearance === 'icon-square');
    }
    _isTruthy(v) {
        if (v === true)
            return true;
        if (typeof v === 'string')
            return v.toLowerCase() === 'true';
        if (typeof v === 'number')
            return v !== 0;
        return false;
    }
    _getButtonTypeAttr() {
        if (this.actionType === 'submit')
            return 'submit';
        if (this.actionType === 'reset')
            return 'reset';
        return undefined;
    }
    _fallbackAriaLabel() {
        var _a;
        if (this.isIconOnly && ((_a = this.icon) === null || _a === void 0 ? void 0 : _a.trim()))
            return this.icon.trim().replace(/[_-]+/g, ' ');
        return 'Button';
    }
    renderIcon() {
        return $ `<span class="material-symbols-outlined btn-icon" aria-hidden="true">${this.icon.trim()}</span>`;
    }
    renderCustomSvg() {
        return $ `<span class="btn-icon btn-custom-svg" aria-hidden="true">${this.customSvg}</span>`;
    }
    renderCustomSvgUrl() {
        return $ `<img class="btn-icon btn-custom-svg" src="${this.customSvgUrl}" alt="" aria-hidden="true">`;
    }
    renderLoader() {
        return $ `<span class="material-symbols-outlined btn-icon btn-loader" aria-hidden="true">progress_activity</span>`;
    }
    renderChevronRight() {
        return $ `<span class="material-symbols-outlined btn-icon btn-chevron" aria-hidden="true">chevron_right</span>`;
    }
    getTrailingIcon() {
        if (this.type === 'tertiary' && this.appearance === 'default') {
            return this.renderChevronRight();
        }
        if (this.isLoading || this.appearance !== 'default') {
            return w;
        }
        if (this.customSvgUrl)
            return this.renderCustomSvgUrl();
        if (this.customSvg)
            return this.renderCustomSvg();
        if (this.icon)
            return this.renderIcon();
        return w;
    }
    renderTextualContent() {
        const leading = this.isLoading ? this.renderLoader() : w;
        const trailing = this.getTrailingIcon();
        const labelTemplate = this.label
            ? $ `<span class="btn-label">${this.label}</span>`
            : w;
        return $ `${leading}${labelTemplate}${trailing}`;
    }
    renderIconOnly() {
        if (this.customSvgUrl)
            return this.renderCustomSvgUrl();
        if (this.customSvg)
            return this.renderCustomSvg();
        if (this.icon)
            return this.renderIcon();
        return $ ``;
    }
    renderContent() {
        if (this.isIconOnly)
            return this.renderIconOnly();
        return this.renderTextualContent();
    }
    _emitClick(ev) {
        this.dispatchEvent(new CustomEvent('cvt-click', {
            detail: { originalEvent: ev },
            bubbles: true,
            composed: true,
        }));
    }
    _ariaSaysDisabled() {
        var _a;
        const a = (_a = this.ariaList) !== null && _a !== void 0 ? _a : {};
        return this._isTruthy(a['aria-disabled']) || this._isTruthy(a.disabled);
    }
    _mergedAria() {
        var _a, _b;
        const merged = {};
        const isLink = !!this.href;
        for (const [rawK, rawV] of Object.entries((_a = this.ariaList) !== null && _a !== void 0 ? _a : {})) {
            const k = normalizeKey(rawK);
            const v = toStringVal(rawV);
            if (v && !(isLink && GenericButtonUpdated.LINK_INVALID_ARIA.has(k))) {
                merged[k] = v;
            }
        }
        if (this.isLoading && merged['aria-busy'] === undefined) {
            merged['aria-busy'] = 'true';
        }
        const hasVisibleText = !!((_b = this.label) === null || _b === void 0 ? void 0 : _b.trim());
        if (!hasVisibleText && !this.skipAriaFallback && merged['aria-label'] === undefined) {
            merged['aria-label'] = this._fallbackAriaLabel();
        }
        return merged;
    }
    _applyAriaTo(el, next) {
        const prev = this._lastAppliedAria;
        for (const k of Object.keys(prev)) {
            if (!(k in next))
                el.removeAttribute(k);
        }
        for (const [k, v] of Object.entries(next)) {
            if (prev[k] !== v)
                el.setAttribute(k, v);
        }
        this._lastAppliedAria = next;
    }
    _syncAria() {
        const el = this.renderRoot.querySelector('.btn');
        if (!(el instanceof HTMLElement))
            return;
        this._applyAriaTo(el, this._mergedAria());
    }
    updated() {
        this._syncAria();
    }
    _getRelAttribute() {
        const parts = [];
        if (this.target === '_blank') {
            parts.push('noopener', 'noreferrer');
        }
        if (this.isNoFollow) {
            parts.push('nofollow');
        }
        return parts.length > 0 ? parts.join(' ') : '';
    }
    render() {
        const classes = `btn ${this.class} ${this.type} ${this.appearance} ${this.isLoading ? 'is-loading' : ''}`;
        const dirAttr = this.rtl ? 'rtl' : 'ltr';
        const ariaDisabledFromBack = this._ariaSaysDisabled();
        const isDisabled = this.disabled || ariaDisabledFromBack;
        if (!this.href) {
            return $ `<button id="${l(this.id || undefined)}" type="${l(this._getButtonTypeAttr())}" class="${classes}" ?disabled="${isDisabled}" dir="${dirAttr !== null && dirAttr !== void 0 ? dirAttr : w}" @click="${this._handleClick}">${this.renderContent()}</button>`;
        }
        return $ `<a id="${l(this.id || undefined)}" class="${classes}" dir="${dirAttr !== null && dirAttr !== void 0 ? dirAttr : w}" @click="${this._handleClick}" target="${this.target || w}" href="${isDisabled ? w : this.href}" tabindex="${isDisabled ? '-1' : w}" ?disabled="${this.disabled}" rel="${this._getRelAttribute() || w}">${this.renderContent()}</a>`;
    }
}
GenericButtonUpdated.styles = css_248z;
GenericButtonUpdated.LINK_INVALID_ARIA = new Set([
    'aria-pressed',
    'aria-checked',
]);
__decorate([
    e({ type: String, reflect: true })
], GenericButtonUpdated.prototype, "styleType", void 0);
__decorate([
    e({ type: String, reflect: true })
], GenericButtonUpdated.prototype, "color", void 0);
__decorate([
    e({ type: String, reflect: true })
], GenericButtonUpdated.prototype, "type", void 0);
__decorate([
    e({ type: String, reflect: true })
], GenericButtonUpdated.prototype, "appearance", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "label", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], GenericButtonUpdated.prototype, "disabled", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], GenericButtonUpdated.prototype, "rtl", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], GenericButtonUpdated.prototype, "isLoading", void 0);
__decorate([
    e({ type: Boolean, reflect: true })
], GenericButtonUpdated.prototype, "isNoFollow", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "href", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "icon", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "customSvg", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "customSvgUrl", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "id", void 0);
__decorate([
    e({ attribute: false })
], GenericButtonUpdated.prototype, "onClick", void 0);
__decorate([
    e({ type: String, reflect: true })
], GenericButtonUpdated.prototype, "target", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "actionType", void 0);
__decorate([
    e({ attribute: 'arialist', converter: ariaListConverter })
], GenericButtonUpdated.prototype, "ariaList", void 0);
__decorate([
    e({ type: Boolean })
], GenericButtonUpdated.prototype, "skipAriaFallback", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "popupId", void 0);
__decorate([
    e({ type: Boolean })
], GenericButtonUpdated.prototype, "closeModal", void 0);
__decorate([
    e({ type: Boolean })
], GenericButtonUpdated.prototype, "download", void 0);
__decorate([
    e({ type: String })
], GenericButtonUpdated.prototype, "class", void 0);
__decorate([
    t()
], GenericButtonUpdated.prototype, "modals", void 0);
customElements.define('generic-button-updated', GenericButtonUpdated);

export { GenericButtonUpdated, ariaListConverter, parseAriaList };
